import React from 'react';
import InternalBar from "../../TopLayout/InternalBar/InternalBar";
import {useHistory} from "react-router-dom";
import { globalText } from '../tutorDetailsOverviewConfig';

function TaskCardMini({cards, scrollNav, config = {}}) {
    const history = useHistory();
    const text = config.text || {};
    const images = config.images || {};
    const taskHeading = text.task_heading || 'Complete tasks & Win exciting rewards.';
    const taskHeadingParts = taskHeading.match(/^(.*?&)\s*(.*)$/);
    const taskHeadingPrefix = taskHeadingParts ? `${taskHeadingParts[1]} ` : taskHeading;
    const taskHeadingHighlight = taskHeadingParts ? taskHeadingParts[2] : '';
    const filteredItem = Array.isArray(cards) ? cards.slice(0, 2).filter((item) => !item?.isComplete) : [];
    return (
        <div className="task-card-mini-container">
            <h2>{taskHeadingPrefix}<span>{taskHeadingHighlight}</span></h2>
            {filteredItem.map((item, index) => (
                <div className="task-card-mini" key={index}>
                    <h3>
                        {item?.task || "Task Name"}
                        <img
                            src={images.task_forward_icon || 'https://cdn-cp-assets-public.classplus.co/web/courseWebview/content/card-forward-white-icon.png'}
                            alt="overview card forward"
                            height={12}
                        />
                    </h3>
                    {item?.statType === 3 ? (
                        <p>{item?.completedText || "Completed Text"}</p>
                    ) : (
                        <p>
                            {item?.total || 0} {item?.completedText || ""}
                        </p>
                    )}
                    <InternalBar height={12} width={item?.percentage || 0} />
                </div>
            ))}
            <button className="btn-action" onClick={() => {scrollNav(0);window.scrollTo({top: 0, behavior: 'smooth'});history.replace({pathname: "/tutor/details/tasks"});}}>
                {globalText.view_tasks_label || 'View All Tasks'}
            </button>
        </div>
    );
}

export default TaskCardMini;
